// extracted by mini-css-extract-plugin
export default {"cls1":"QuestionStyles-cls1___6bf015724bc9ba90e49","cls2":"QuestionStyles-cls2__f1b31c0b2001f1a97478 QuestionStyles-cls1___6bf015724bc9ba90e49"};